import React, { useState } from "react";
import { Link } from "react-router-dom";
import api from "../api";

const ForgotPassword = () => {
    const [email, setEmail] = useState("");
    const [msg, setMsg] = useState("");
    const [error, setError] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMsg("");
        setError("");

        try {
            await api.post("/api/auth/forgot-password", { email });
            setMsg("If an account exists with that email, a reset link has been sent.");
        } catch (err) {
            setError("Account not found. Please try again.");
        }
    };

    return (
        <div className="pt-5 d-flex align-items-center">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-6 col-lg-4">
                        <div className="card shadow border-0">
                            <div className="card-body p-4">
                                <div className="text-center mb-4">
                                    <h3 className="card-title text-primary">Forgot Password</h3>
                                    <p className="text-muted">Enter your email to reset password</p>
                                </div>

                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label className="form-label">Email Address</label>
                                        <input
                                            type="email"
                                            className="form-control"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <button type="submit" className="btn btn-primary w-100 py-2">
                                        Send Reset Link
                                    </button>
                                </form>

                                {msg && <div className="alert alert-success mt-3">{msg}</div>}
                                {error && <div className="alert alert-danger mt-3">{error}</div>}

                                <div className="text-center mt-3">
                                    <Link to="/login" className="text-muted text-decoration-none">
                                        <i className="las la-arrow-left me-1"></i>
                                        Back to Login
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;
